import { useState } from 'react'
import reportAction from '@/utils/statistic'
import { uploadFile } from '@/api/chat'
import { chatState } from '@/store'
import { message } from '@/App'
import { DocFileAccept, VideoFileAccept } from '@/constants/index'
import { convertSize } from '@/utils/formate'
import { nanoid } from 'nanoid'

const useInputUpload = () => {
  const [uploadLoading, setUploadLoading] = useState(false)

  // 合并校验
  const beforeUpload = async (file: any) => {
    const fileExtension = `.${file.name?.split('.').pop().toLowerCase()}` || ''
    console.log('beforeUpload =>', {
      fileExtension,
      type: file.type,
    })
    if (file.type.match('image.*')) {
      await beforeUploadImage(file)
    } else if (file.type.match('audio.*')) {
      await beforeUploadAudio(file)
    } else if (VideoFileAccept.includes(fileExtension)) {
      await beforeUploadVideo(file)
    } else if (DocFileAccept.includes(fileExtension)) {
      await beforeUploadDoc(file)
    } else {
      message.error('暂不支持的文件类型')
    }
    return false
  }

  // 独立的文件校验
  const beforeUploadImage = async (file: any) => {
    if (chatState.inputFileList?.length > 5) {
      message.error('最多上传6张图片')
      return false
    }
    const fileSize = file.size / 1024 / 1024
    file.url = URL.createObjectURL(file)
    if (!file.type.match('image.*')) {
      message.error('请检测文件类型是否为图片')
      return false
    }
    if (fileSize > 10) {
      message.error(`单张图片不大于10M，文件名：${file.name}`)
      return false
    }
    console.log('beforeUploadImage =>', file)
    await onChange('pic', file)

    return false
  }

  const beforeUploadAudio = async (file: any) => {
    const fileSize = file.size / 1024 / 1024
    if (!file.type.match('audio.*')) {
      message.error('请检测文件类型是否为音频')
      return false
    }
    if (fileSize > 20) {
      message.error(`音频大小需20M以内，文件名：${file.name}`)
      return false
    }

    await onChange('audio', file)
    return false
  }

  const beforeUploadVideo = async (file: any) => {
    const fileExtension = `.${file.name?.split('.').pop().toLowerCase()}` || ''
    const fileSize = file.size / 1024 / 1024

    if (!VideoFileAccept.includes(fileExtension)) {
      message.error('请检测文件类型是否为视频')
      return false
    }
    if (fileSize > 50) {
      message.error(`视频大小需50M以内，文件名：${file.name}`)
      return false
    }

    await onChange('video', file)
    return false
  }

  const beforeUploadDoc = async (file: any) => {
    console.log('beforeUploadDoc =>', file)
    const fileSize = file.size / 1024 / 1024
    const fileExtension = `.${file.name?.split('.').pop().toLowerCase()}` || ''

    if (!DocFileAccept.includes(fileExtension)) {
      message.error('文档格式暂不支持')
      return false
    }
    if (fileSize > 10) {
      message.error(`单个文档不超过10M，文件名：${file.name}`)
      return false
    }
    await onChange('doc', file)
    return false
  }

  const onChange = async (type: string, file: any) => {
    console.log('onChange info =>', {
      type,
      file,
      fileList: chatState.inputFileList,
    })
    const localFile = {
      serverType: type,
      // antd组件自带，其他方式没有
      uid: file.uid || nanoid(),
      type: file.type,
      size: file.size,
      showSize: convertSize(file?.size),
      extension: file.name?.split('.').pop() || '',
      name: file.name,
      progress: 0,
    } as any
    if (type === 'pic') {
      localFile.url = file.url
    }
    const isContinueImage = chatState.inputFileType === type && type === 'pic'
    chatState.inputFileType = type
    chatState.inputFileList = isContinueImage
      ? [...chatState.inputFileList, localFile]
      : [localFile]
    try {
      setUploadLoading(true)
      const { data } = await uploadFile({
        file,
        inputFileList: chatState.inputFileList,
      })
      if (data?.riskMessage) {
        message.error(`${data?.riskMessage}, 文件名为:${localFile.name}`)
        throw new Error('文件风控未通过')
      }

      const existingFile = chatState.inputFileList.find(
        (f: any) => f.uid === localFile.uid,
      )

      // 文件上传后新增字段，其余上传前都有
      existingFile.serverUrl = data?.file_path
      existingFile.serverId = data?.file_id
      console.log('existingFile =>', existingFile)

      reportAction({
        action: 'upload_file',
      })
    } catch (error) {
      chatState.inputFileList = chatState.inputFileList.filter(
        i => i.uid !== localFile.uid,
      )
    } finally {
      setUploadLoading(false)
    }
  }

  return {
    uploadLoading,
    beforeUploadImage,
    beforeUploadAudio,
    beforeUploadVideo,
    beforeUploadDoc,
    beforeUpload,
    onChange,
  }
}

export default useInputUpload
